import {
  Image,
  Size,
  SizeV,
  ExternalImage,
  ExternalImageV,
  MediaV,
  MediaInputValue
} from "@/types/media";
import { pipe } from "fp-ts/function";
import { makeWordPressAjaxRequest } from "@/lib/wordpress/ajax";
import { fold } from "fp-ts/Either";
import * as t from "io-ts";

export const CUSTOM_SIZE_KEY = "breakdance_custom";

type Attachment = { id: number };
type MediaLibraryResponse = Attachment[] | ExternalImage;

export function isExternalImage(
  image: MediaLibraryResponse
): image is ExternalImage {
  return pipe(
    image,
    ExternalImageV.decode,
    fold(
      () => false,
      () => true
    )
  );
}

export async function fetchMediaSizes(id: number): Promise<any> {
  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_image_sizes",
      dataToPost: { id },
      decoder: t.union([t.record(t.string, t.unknown), t.null]),
      friendlyName: "Get image metadata",
      resultKey: "data"
    }),
    fold(
      () => undefined,
      metadata => metadata
    )
  );
}

export async function fetchMediaObject(
  media: MediaLibraryResponse
): Promise<MediaInputValue | undefined> {
  if (isExternalImage(media)) return media;

  const ids = media.map(m => m.id);

  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_image_metadata",
      dataToPost: { ids },
      decoder: t.array(MediaV),
      friendlyName: "Get image metadata",
      resultKey: "data"
    }),
    fold(
      () => undefined,
      metadata => metadata
    )
  );
}

export async function cropImage(
  image: Image,
  width: number | null,
  height: number | null
): Promise<Size | undefined> {
  const dataToPost: { id: number; width?: number; height?: number } = {
    id: image?.id
  };

  if (width) {
    dataToPost.width = width;
  }

  if (height) {
    dataToPost.height = height;
  }

  return pipe(
    await makeWordPressAjaxRequest({
      action: "breakdance_resize_image",
      decoder: SizeV,
      dataToPost,
      resultKey: "data"
    }),
    fold(
      () => undefined,
      size => size
    )
  );
}
